export default "__VITE_ASSET__DuJwXfkT__"